"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createChatContext = createChatContext;
const react_1 = require("react");
function createChatContext() {
    return (0, react_1.createContext)({});
}
